import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import AssetPicker from '../picker/AssetValuePicker'

const AssetsFilterV2 = ({ field, ...props }) => {
  const { t } = useTranslation('common')
  field = field || 'assetIds'
  const label = t('asset')
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()

  return (
    <div>
      <AssetPicker value={value} onChange={handleChange(field)} multiple label={label} {...props} />
    </div>
  )
}

export default AssetsFilterV2
